export enum AttendanceClassStatuses {
  Completely = 1,
  Partially = 2,
  Not = 3
}
